import {AchPayment} from "../models/ach.payment.model";
import {getApiUrl} from "../utils/util-functions";

export const createPaymentAsync = async (paymentObject: {
    amount: string, cvv: string, holderName: string, creditCardNumber: string,
    month: string, year: string, zipCode: string, notes: string, email: string, address: string, locality: string,
    state: string, fingerprintSessionId: string, rainforestPayinId: string, rainforestPayinConfigId: string,
    fullstackToken: string, nmiToken: string, type: string
}, isPayrixPayment: boolean = false, selectedOptionId?: number, selectedAddOnOptionIds: number[] = [],
    isNmiPayment: boolean = false) => {
    let amount = paymentObject.amount;
    if (amount.indexOf('.') === -1) {
        amount = `${amount}.00`;
    } else if (amount.indexOf('.') === amount.length - 2) {
        amount = `${amount}0`;
    } else {
        amount = amount.slice(0, amount.indexOf('.') + 3);
    }
    let apiObject: any = {
        type: paymentObject.type,
        amount: amount,
        account: paymentObject.creditCardNumber || paymentObject.fullstackToken,
        expiry: `${paymentObject.month}${paymentObject.year}`,
        notes: paymentObject.notes,
        postal: paymentObject.zipCode,
        cvv2: paymentObject.cvv,
        holder_name: paymentObject.holderName,
        selected_option_id: selectedOptionId,
        selected_add_on_options_ids: selectedAddOnOptionIds,
        administrative_area: paymentObject.state,
        locality: paymentObject.locality,
        address1: paymentObject.address,
        email: paymentObject.email,
        fingerprint_session_id: paymentObject.fingerprintSessionId,
        payin_id: paymentObject.rainforestPayinId,
        payin_config_id: paymentObject.rainforestPayinConfigId,
        token_id: paymentObject.fullstackToken,
        nmi_token: paymentObject.nmiToken,
    };
    if (isPayrixPayment) {
        apiObject = {
            type: paymentObject.type,
            amount: amount,
            account: paymentObject.creditCardNumber,
            notes: paymentObject.notes,
            selected_option_id: selectedOptionId,
            selected_add_on_options_ids: selectedAddOnOptionIds
        };
    }
    if (isNmiPayment) {
        apiObject = {
            type: paymentObject.type,
            amount: amount,
            account: paymentObject.nmiToken,
            notes: paymentObject.notes,
            selected_option_id: selectedOptionId,
            selected_add_on_options_ids: selectedAddOnOptionIds
        };
    }
    return fetch(getApiUrl() + '/payment', {method: 'POST', body: JSON.stringify(apiObject)})
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}

export const getPayrixTokenAsync = async (apiURL: string, paymentObject: { cvv: string, cardholderName: string, creditCardNumber: string, month: string, year: string, zipCode: string }) => {
    const apiObject = {
        'Card': {
            'CardholderName': paymentObject.cardholderName,
            'CardNumber': paymentObject.creditCardNumber.replace(/\D/g, ''),
            'ExpiryMonth': paymentObject.month,
            'ExpiryYear': '20' + paymentObject.year,
            'Ccv': paymentObject.cvv
        },
        'DeviceData': null
    };
    return fetch(apiURL, {
        method: 'POST',
        body: JSON.stringify(apiObject),
        headers: {'Content-Type': 'application/json'}
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}

export const getPayrixUSTokenAsync = async (apiURL: string, publicApiKey: string, merchantID: string, paymentObject: { cvv: string, cardholderName: string, creditCardNumber: string, month: string, year: string, zipCode: string }) => {
    let body = new FormData();
    body.append('payment[number]', paymentObject.creditCardNumber.replace(/\D/g, ''));
    body.append('payment[expiration]', `${paymentObject.month}${paymentObject.year}`);
    body.append('payment[cvv]', paymentObject.cvv);
    body.append('customer[merchant]', merchantID);
    const cardholderNameParts = paymentObject.cardholderName.split(' ');
    body.append('customer[first]', cardholderNameParts[0] || '');
    body.append('customer[last]', cardholderNameParts[1] || '');
    body.append('customer[zip]', paymentObject.zipCode);
    return fetch(apiURL, {
        method: 'POST',
        body: body,
        headers: {apiKey: publicApiKey}
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}


export const createAchPaymentAsync = async (paymentObject: AchPayment, selectedOptionId?: number, selectedAddOnOptionIds: number[] = []) => {
    let amount = paymentObject.amount;
    if (amount.indexOf('.') === -1) {
        amount = `${amount}.00`;
    } else if (amount.indexOf('.') === amount.length - 2) {
        amount = `${amount}0`;
    } else {
        amount = amount.slice(0, amount.indexOf('.') + 3);
    }
    paymentObject.amount = amount;
    paymentObject.type = 'ach';
    if (selectedOptionId) {
        paymentObject['selected_option_id'] = selectedOptionId;
        paymentObject['selected_add_on_options_ids'] = selectedAddOnOptionIds;
    }
    return fetch(getApiUrl() + '/payment', {method: 'POST', body: JSON.stringify(paymentObject)})
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}
